import * as React from 'react';
import { LinkButton } from '@cian/ui-kit/button';
import { Header1 } from '@cian/ui-kit/typography';
import { Layout } from '../Layout';
import * as styles from './styles.css';

export const Banks = ({
  children,
  title,
  mortgageUrl,
}: React.PropsWithChildren<{ title: string; mortgageUrl: string }>) => {
  return (
    <Layout>
      <div data-nav-tab="mortgage/Ипотека" id="mortgage" className={styles['nav_container']}>
        <div className={styles['banks']}>
          <Header1 as="h2">{title}</Header1>
          <div className={styles['container']}>{children}</div>
          <div className={styles['mortgage']}>
            <LinkButton size={'XS'} theme={'stroke_primary'} target={'_blank'} href={mortgageUrl}>
              Оформить ипотеку онлайн
            </LinkButton>
          </div>
        </div>
      </div>
    </Layout>
  );
};

Banks.displayName = 'Banks';
